import log from "loglevel";
import { GetFromScript } from "./script-data.service";

const dictionary = GetFromScript("translations");

export function GetTranslations(namespace = null) {
    if (namespace !== null) {
        return dictionaryAtNamespace(namespace);
    }
    return dictionary;
}

export function Translate(key, namespace = null) {
    let translation = null;
    namespace = namespace || key;
    try {
        let dict = dictionaryAtNamespace(namespace);
        translation = dict[key];
    } catch (err) {
        log.error(err);
    }
    if (!translation) {
        log.warn(`No translation found for "${namespace}.${key}"`);
        return key;
    }
    return translation;
}

function dictionaryAtNamespace(namespace){
    const nsParts = namespace.split(".");
    var treePosition = dictionary;
    for (let i = 0; i < nsParts.length; i++) {
        const element = nsParts[i];
        treePosition = treePosition[element]
    }
    return treePosition;
}

export default {
    GetTranslations,
    Translate
};